module.exports = __webpack_public_path__ + "908e4d2e/img/verified-icon.f93bbc14.svg";